import Vue from '@front-app/vendor/vue';
import { router } from '@front-app/router/index';
import { loadNeededPolyfills } from '@front-app/polyfills/polyfills';
import { registerServiceWorker } from '@front-app/services/ServiceWorker/registerServiceWorker';
import { usePhoenixCookie } from '@front-app/hooks/usePhoenixCookie';
import { createPinia } from 'pinia';
import { initAllIcons } from './vendor/icons';
import App from './App.vue';
import i18n, { initI18n } from './i18n';
import { RefreshPageStore } from './store/singletons/RefreshPage';

initAllIcons();

async function start() {
	await Promise.all([
		loadNeededPolyfills(),
		initI18n(i18n),
	]);
	RefreshPageStore.init();
	registerServiceWorker();

	usePhoenixCookie().setIsPhoenixUser();
	usePhoenixCookie().setRedirectSetting(true);

	new Vue({
		router,
		i18n,
		render: (h) => h(App),
		pinia: createPinia(),
	})
		.$mount('#app');
}

start();
